import React from "react";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import Navbar from "../components/Navbar";
import Hero from "../components/sections/Hero";
import MarqueeBand from "../components/MarqueeBand";
import WhatWeDo from "../components/sections/WhatWeDo";
import WhyAnantora from "../components/sections/WhyAnantora";
import Team from "../components/sections/Team";
import Contact from "../components/sections/Contact";

const LENIS_OPTIONS = {
  lerp: 0.08,
  duration: 1.4,
  smoothWheel: true,
  wheelMultiplier: 0.85,
  touchMultiplier: 1.5,
};

const Landing = () => (
  <ReactLenis root options={LENIS_OPTIONS}>
    <div style={{ backgroundColor: "#030303", color: "#F4F4F0", overflowX: "hidden" }}>
      <Navbar />
      <Hero />
      <MarqueeBand />
      <WhatWeDo />
      <WhyAnantora />
      <Team />
      <Contact />
    </div>
  </ReactLenis>
);

export default Landing;
